<script>
  import { createEventDispatcher } from "svelte";
  import { apiMethods } from "../../Services/index.svelte";
  import { showError, showInfo } from "../../Utils/utilFunctions.svelte";

  export let patientEncounter = {};
  export let showLabel = true;
  const dispatch = createEventDispatcher();

  let isCalling = false;

  const onToggle = async () => {
    if (isCalling || !patientEncounter.id) return;
    isCalling = true;
    await apiMethods.putMethod
      .updateDisableCommunication(
        patientEncounter.id,
        patientEncounter.disableNotifications ? 0 : 1
      )
      .then((res) => {
        isCalling = false;
        if (patientEncounter.disableNotifications) {
          showInfo("Patient Communication Enabled");
        } else {
          showInfo("Patient Communication Disabled");
        }
        dispatch("disableNotificationsToggled");
      })
      .catch((err) => {
        showError(err);
        isCalling = false;
      });
  };
</script>

<div class="flex flex-row gap-x-2 items-center">
  {#if showLabel}
    <label for="disableCommunicationToggle" class="text-[14px] cursor-pointer">
      Disable Communication</label
    >
  {/if}
  <input
    type="checkbox"
    id="disableCommunicationToggle"
    class="toggle toggle-secondary"
    checked={patientEncounter.disableNotifications}
    on:click|preventDefault={onToggle}
    disabled={isCalling}
  />
</div>
